import axios from 'axios';
import Utils from 'utils';
import { useCallback, useState } from 'react';

export const call_GetAggiornamentiDownload = async (urlPrefix = '') => {
  const config = {
    method: 'get',
    url: `${process.env.REACT_APP_API_URL_AZURE}${process.env.REACT_APP_AUTH_PORT_POST}${urlPrefix}${process.env.REACT_APP_GET_AGGIORNAMENTI_DOWNLOAD}`,
    headers: {
      accept: 'text/plain',
      'Content-Type': 'application/json-patch+json'
    },
    responseType: 'blob'
  };
  const response = await axios(config);
  const responseData = response.data;
  const filename = Utils.getFileNameFromHeader(response.headers["content-disposition"]);
  responseData.filename = filename;
  // add transformers here if needed
  const transformedData = responseData?.size ? responseData : [];

  return transformedData;
};

const useGetAggiornamentiDownload = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const execute = async () => {
    try {
      setIsLoading(true);
      const responseData = await call_GetAggiornamentiDownload();
      setData(responseData);
      setIsLoading(false);
      return responseData;
    } catch (e) {
      setError(e);
      setIsLoading(false);
      throw e;
    }
  };

  const reset = () => {
    setIsLoading(false);
    setData(null);
    setError(null);
  };

  return {
    isLoading,
    error,
    data,
    execute: useCallback(execute, []), // to avoid infinite calls when inside a `useEffect`
    reset: useCallback(reset, []) // to avoid infinite calls when inside a `useEffect`
  };
};

export default useGetAggiornamentiDownload;
